<template>
  <el-container class="indexhome" :class="languageapart?'indexbground':''">
    <div class="interbox" v-if="btnFlag"  @click="handleLogin" > {{$t('Claim FREE Package')}} </div>
        <div v-show="dialogVisible" class="show-captcha"  @click="closebg">
        <div  class="show-captcha-div" @click.stop>
                <div ref="captcha"></div>
                <!-- <button ref="popups" class=" captcha-botton"> {{$t('Click Refresh Verification Code')}}</button>                     -->
        </div>
        </div>
    <img  v-if="!languageapart" class="rightimg" src="../assets/share/Vector 5.png" alt="">
      <img  v-if="!languageapart" class="img1" src="../assets/share/Vector.png" alt="">
       <img  v-if="!languageapart" class="img2" src="../assets/share/que.png" alt="">
        <img  v-if="!languageapart"  class="img3" src="../assets/share/Group 10707.png" alt="">

          <img v-if="!languageapart" class="leftimg" src="../assets/share/Vector 6.png" alt="">
        <img v-if="!languageapart" class="four" src="../assets/share/Vector.png" alt="">
        <img v-if="!languageapart" class="five" src="../assets/share/Ellipse 1591.png" alt="">

<!-- en页面img -->
        <img v-if="languageapart"  class="six" src="../assets/share/logo.png" alt="">
        <img  v-if="languageapart" class="seven" src="../assets/share/Vector 47.png" alt="">
         <img  v-if="languageapart" class="eight" src="../assets/share/Vector 48.png" alt="">
         <img  v-if="languageapart" class="nite" src="../assets/share/Vectoryu.png" alt="">


    <div class="total">
        <img  v-if="!languageapart" class="one" src="../assets/share/shareTop.png" alt="">
         <span v-else class="enspan">Claim Your Free Trial Classes</span>

      <div class="textimg" :class="languageapart?'textimgen':'' ">
        <div >
          <img v-if="languageapart" src="../assets/share/Star2.png" alt="">
          <img  v-else src="../assets/share/Star.png" alt="">
          <span> {{$t('sharefree.educators')}} </span>
        </div>
        <div>
          <img v-if="languageapart" src="../assets/share/Star2.png" alt="">
          <img  v-else src="../assets/share/Star.png" alt="">
          <span> {{$t('sharefree.sessions')}} </span>
        </div>
        <div>
          <img v-if="languageapart" src="../assets/share/Star2.png" alt="">
          <img  v-else src="../assets/share/Star.png" alt="">
          <span> {{$t('sharefree.parents')}} </span>
        </div>
        <div>
          <img v-if="languageapart" src="../assets/share/Star2.png" alt="">
          <img  v-else src="../assets/share/Star.png" alt="">
          <span>  {{$t('sharefree.Match')}} </span>
        </div>
      </div>

      <div class="ocntrnon" v-if="!languageapart">
        <div>
          <img src="../assets/share/reading.png" alt="">
          <!-- <img src="../assets/share/Frame.png" class="frameimg" alt=""> -->
          <span>英语阅读</span>
        </div>
        <div>
          <img src="../assets/share/chess.png" alt="">
          <!-- <img src="../assets/share/Frame.png" class="frameimg" alt=""> -->
          <span>国际象棋</span>
        </div>
        <div>
          <img src="../assets/share/math.png" alt="">
          <!-- <img src="../assets/share/Frame.png" class="frameimg" alt=""> -->
          <span>数学逻辑</span>
        </div>
        <div>
          <img src="../assets/share/coding.png" alt="">
          <!-- <img src="../assets/share/Frame.png" class="frameimg" alt=""> -->
          <span>编程</span>
        </div>

      </div>
      <div class="kemu" v-if="!languageapart">
          <span>还有更多科目</span>
      </div>

      <!-- en页面img-->
        <img  v-if="languageapart"  class="ocntrnon_en"  src="../assets/share/Group 11271.png" alt="">
        <img  v-if="languageapart" class="ten" src="../assets/share/Group 11272.png" alt="">

    </div>
    <el-main :class="languageapart?'elmain_en':'' ">
      <!-- 登录 -->
      <div class="login_form">

        <el-form :model="shareForm" label-position="top" :rules="signValidate"  ref="shareForm" label-width="100px" class="demo-shareForm" hide-required-asterisk>
          <el-form-item class="elinput" :label="$t('global.name')"><!-- :label="$t('global.name')" -->
            <el-input @focus="isActive1 = true"    @blur="isActive1 = false"  :class="isActive1?'inputfocus':'' "  v-model="shareForm.child_nickname" :placeholder="$t('global.name')" class="infocus"></el-input>
          </el-form-item>
          <el-form-item :label="$t('global.phone')" prop="phone" ><!-- $t('global.hPhoneNum') -->
              <el-input  @focus="isActive2 = true"    @blur="isActive2 = false"  :class="isActive2?'inputfocus':'' " oninput="value=value.replace(/\D/gi,'')" v-model="shareForm.phone" :placeholder="$t('global.plase') " :maxlength="max" class="infocus">
                  <el-select ref="select" :placeholder="$t('Country Code')" @focus="isActive5 = true"    @blur="isActive5 = false"  :class="isActive5?'inputfocus5':'' " v-model="shareForm.areaCode" slot="prepend" style="width: 156px" @change="changeCode" class="infocus">
                      <el-option v-for="(item, index) in areaCodeData" :label="` ${item.title} `" :key="item" :value="item.id">
                        <div class="selectoption">
                            <span> <img :src="item.flag" alt=""> {{item.title}} </span>
                            <span> +{{ item.country_code }}</span>
                        </div>

                    </el-option>
                  </el-select>
              </el-input>
          </el-form-item>

          <el-form-item  prop="email" class="elinput"  :label="$t('global.email')"><!-- :label="$t('global.email')" -->
              <el-input  @focus="isActive3 = true"    @blur="isActive3 = false"  :class="isActive3?'inputfocus':'' " v-model="shareForm.email" placeholder="example@gmail.com" class="infocus"></el-input>
          </el-form-item>
              <el-form-item   class="elinput" :label="$t('global.wechat')" >
                <!--  :label="$t('global.wechat')" -->
                   <el-input  @focus="isActive4 = true"    @blur="isActive4 = false"  :class="isActive4?'inputfocus':'' " v-model="shareForm.wechat_id" placeholder="wechat ID" class="infocus"></el-input>
              </el-form-item>
          <el-button  :class="languageapart?'buttonen':'' " type="primary" @click="submitForm()">{{$t('global.submit') }}</el-button>
        </el-form>

        <img class="founten" src="../assets/share/one-finger 1.png" alt="">
      </div>
    </el-main>

  </el-container>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=UA-173502309-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-173502309-1');
</script>
<script>
import { setStore, getStore, keys } from '@/store';
export default {
  name: 'shareRegister',
  data () {
    // 手机号验证
    const loginCheck = async (rule, value, callback) => {

      let reg = /^\d{1,}$/
      if (value.length < 1) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.phoneEmpty')))
      } else if (!reg.test(value)) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.phoneError')))
      } else {
        this.changeFlag = 1
        callback()
      }
    };
    //邮箱验证
      var checkEmail = (rule, value, callback) => {
            const mailReg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/;
            if (!value) {
                return callback(new Error(this.$t('errorprompt.emailEmpty')));
            }
            setTimeout(() => {
                if (mailReg.test(value)) {
                    callback();
                } else {
                    callback(new Error(this.$t('errorprompt.emailError')));
                }
            }, 100);
        };
    return {
      qvhao: [],
      areaCodeData: [],
      dropDownValue: '',
      valueMeta: [],
      shareForm: {
        phone: '',
        areaCode: '',
        code: '',
        child_nickname:'',
        email:'',
        wechat_id:'',
      },
      signValidate: {
        phone: [
          { required: true, validator: loginCheck, trigger: 'blur' },
          { min:10, message: this.$t('errorprompt.phoneError'), trigger: 'blur' },
        ],
        email: [{required: true, validator: checkEmail, trigger: 'blur' }],
      },
      changeFlag: 1,
      languageapart:false,
      max:10,
      isActive1:false,
      isActive2:false,
      isActive3:false,
      isActive4:false,
      isActive5:false,
      flag:'',
      invite_code:'',
       dialogVisible: false,
            input:'',
            screenWidth:'',
            messagecode:false
    }
  },
  created () {

    console.log(navigator.language)
    var ual = getStore(keys.lang) ||navigator.language
    if (ual.indexOf('en') > -1) {
      this.languageapart=true

    } else if (ual.indexOf('zh') > -1) {
      this.languageapart=false
    }
    this.getCountryCode()

    function gethtmlfontsize(){
      // 三个步骤:
      // 1.获取html的宽,
      let htmlwidth=document.documentElement.clientWidth || document.body.clientWidth;//有些浏览器documentElement获取不到,那就使用后面的body
      console.log(htmlwidth);
      // 2.htmlDom
      let htmlDom=document.getElementsByTagName("html")[0]
      // console.log(htmlDom);
      //3.设置根元素样式
      htmlDom.style.fontSize=100*htmlwidth/375+'px';

    htmlDom.style.width = '100%';
    }
    // 调用一次
    gethtmlfontsize();
    // 添加监听事件(resize是监听的意思)
    window.addEventListener('resize',gethtmlfontsize)
  },
  mounted () {
    this.invite_code=this.$route.query.invite_code
    var self = this;
		    var options = {
		      element: this.$refs.captcha,
		      captchaId: "2e3422055bf14588a401899f1d8b25b6",
		      width: "320px",
              mode: 'embed',
              apiVersion: 2,
               lang :this.$i18n.locale=='en'?'en':'zh-CN',
              onVerify:(err,data)=>{   //验证之后的回调函数,err验证失败才有值
                   if (err){
                    this.input=''
                    return
                  }
                  if(data){
                      this.input=data.validate
                      this.dialogVisible=false
                      this.submitForm ()
                      self.instance && self.instance.refresh();
                    //    console.log(data.validate)
                  }
              }
		    };
		    initNECaptcha(options, function onLoad(instance) { //初始化成功
		    //   console.log(instance);
		      self.instance = instance;
		    },
            function onerror (err) { //初始化失败
                console.log(err)
            }
            );
		    this.$refs.popups.addEventListener("click", function() {
		      self.instance && self.instance.refresh();
		    });
    // let phone = navigator.userAgent// 设备机型的相关信息
    // phone = phone.substring(phone.indexOf('(') + 1, phone.indexOf(';'))// 处理信息，输出iphone
    // console.log(phone)
    // var u = navigator.userAgent
    // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    // var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // console.log(isAndroid)
    // console.log(isiOS)
    // this.shareForm.user_agent = isiOS ? 'iphone' : (isAndroid ? 'android' : '')
  },
  methods: {

    changeCode(){
        this.areaCodeData.map((item) => {
            if(this.shareForm.areaCode == item.id){
                this.shareForm.code = item.country_code
                this.flag=item.flag
            }
        });
        if(this.shareForm.code=='86'){
          if(this.shareForm.phone.length>11){
            this.shareForm.phone = ''
          }
          this.max = 11
          // this.signValidate.phone[1].min=1
        }else if(this.shareForm.code=='1'){
          if(this.shareForm.phone.length>10){
            this.shareForm.phone = ''
          }
          this.max = 10
          // this.signValidate.phone[1].min=1
        }else{
          this.max=15
          // this.signValidate.phone[1].min=6
        }
        this.$refs['select'].$el.children[0].children[1].setAttribute(
            'style',
            // 'background:url('+ this.flag +') no-repeat;background-size: 21px 15px;background-position: 12px 13px;padding: 0 52px  0   49px; color: #111827;font-family: "Inter";font-weight: 500;font-size: 14px;'
            'padding: 0 0px 0 40px;'
          )
        this.$refs['select'].$el.children[0].children[0].src=this.flag;
        this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:block;'
          )
          this.$refs['select'].$el.children[0].children[2].children[0].innerHTML="+"+this.shareForm.code;
      },
    dropDownSearch () {
      var _this = this
      if (_this.dropDownValue) {
        _this.areaCodeData = []
        _this.qvhao.find(item => {
          let name = item.title + ' +' + item.country_code
          if (name.indexOf(_this.dropDownValue) != -1) {
            _this.areaCodeData.push(item)
          }
        })
      } else {
        _this.areaCodeData = _this.qvhao
      }
    },
    //关闭弹窗
        closebg(){
      this.dialogVisible=false
    },
    //
    // 登录
    submitForm () {
      this.$refs.shareForm.validate((valid, msg) => {
        if (!valid) {
          // this.$message(msg['phone'][0].message || msg['email'][0].message || msg['phone'][0].newPassword || msg['ConfirmNewPassword'][0].message)
          return false
        }
        if(!this.shareForm.areaCode){
          alert(this.$t('Please select your country code'))
          return false
        }
        if(this.input==''){
            this.dialogVisible=true
            return
        }else{
        // var that=this
        this.$http.post('/api/signUpUser', {
          'mobile': this.shareForm.phone,
          'country_code': this.shareForm.code,
          // 'invite_code': this.$route.query.invite_codem,
          'child_nickname':this.shareForm.child_nickname,
          'email':this.shareForm.email,
          'wechat_id':this.shareForm.wechat_id,
          'landingpage_id':12,
          'captcha':this.input,
          ...this.$route.query,
        }).then((res) => {
          this.input=''
          if (res.data.code == 200) {
            this.toLog(res.data.data.user_sn)
            setStore(keys.userInfo, res.data.data);
            // Query the newly registered parent so the result page shows the
            // salesperson that was actually assigned during registration.
            this.$router.push({ path: '/salecard' ,query:{invite_code:res.data.data.invite_code}})
            // setTimeout(() => {
            //   // window.location.href = res.data.data.url
            //   this.$router.push({ path: '/salecard' ,query:{invite_code:this.invite_code}})
            // }, 1000);
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        })}
      })
    },
    // 国家区号
    getCountryCode () {
      this.$http.get('/api/dict/countries?page=1&pagesize=999&keywords=&country_code=').then((res) => {
        this.qvhao = res.data.data
        this.areaCodeData = res.data.data
        setStore(keys.areaCodeList,res.data.data)

        // this.shareForm.areaCode = this.areaCodeData[0].id
        // this.shareForm.code = this.areaCodeData[0].country_code

        var tag="<span>"+this.shareForm.code+"</span> ";
        var img="<img >"
        this.$refs['select'].$el.children[0].children[0].insertAdjacentHTML("beforeBegin",img);
              this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:none;'
          )
        this.$refs['select'].$el.children[0].children[2].children[0].insertAdjacentHTML("beforeBegin",tag);
      })
    },
    // 国家区号
    toLog (user_sn) {
      this.$http.post('/api/addCheckPointsLog',
       { type:3, user_sn:user_sn, value:'landingpage-id:12' }).then((res) => {
        this.qvhao = res.data.data
        this.areaCodeData = res.data.data
        setStore(keys.areaCodeList,res.data.data)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
//验证码插件弹图位置
    /deep/ .yidun_intellisense--light .yidun_classic-container{
       bottom: 0;
       top: auto;
    }
   /deep/ .yidun_popup.yidun_popup--light .yidun_modal{
       bottom: 0;
       top: auto;
       left: 0;
       width: 100%;
       position: absolute;
    }
//--------------------------------------------
//弹窗样式
.captcha-botton{
  width: 90%;
  height: 40px;
   border-radius:6px;
   cursor: pointer;
       background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    border: none;
}
//图片滑动验证码样式
.show-captcha{
   position: fixed;
   display: flex;
   justify-content:center;
   align-items:center;
   top: 0%;
   left: 0%;
   right: 0;
   bottom: 0;
   background-color: rgba(0, 0, 0, 0.3);
   z-index: 99999999999;
   .show-captcha-div{
       display: flex;
       justify-content : center;
       align-items:center;
       flex-direction:column;
       width: 350px;
       height: 350px;
       background: #fff;
       padding: 5px 5px;
       position: relative;
       div{
         text-align: center;
         box-sizing: border-box;
       }
       button{
          //  position: absolute;
          //  bottom: 10px;
           width: 80%;
           margin-top: 20px;
          //  left: 10%;
       }

   }
}
/deep/.el-select .el-input {
  .el-input__inner{
    padding: 0 0 0 12px;

  }
    img{
        width: 17px;
        position: absolute;
        left: 12px;
        bottom: 12px;
    }
}

.selectoption{
        width: 280px;
        display: flex;
        justify-content:space-between;
        img{
           width: 15px;
            // height: 15px;
            margin-right: 16px;
        }
        span{
          display: flex;
          align-items: center;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;

            color: #111827;
        }
    }

/deep/.el-select .el-input .el-input__icon{
    width: 7px;
    font-size: 9px;
    padding-right: 7px;
}
    /deep/.el-input__suffix{
        display: flex;
        align-items:center;
        margin: auto;
        span:nth-child(1){
            display: block;
            font-style: normal;
            font-family: Arial;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            margin: auto;
            padding-left: 5px;
            padding-right: 2px;
            color: #111827;
            // width: 30px;
                }

    }
body {
    overflow-x: hidden;
    box-sizing: border-box;
    font-family: YuanCuGBK;
}
.indexhome{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #FFA4A4;
    margin: 0 auto;
    position: relative;
    font-family: YuanCuGBK;
    .img1{
      position: absolute;
       top: 0.18rem;
       left:0.18rem;
    }

    .rightimg{
      position: absolute;
        right: 0px;
       bottom: 0;
       z-index: 0;
    }
    .img2{
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 0;
      height:2rem;
    }

      .leftimg{
        position: absolute;
        left: 0px;
        top:30%;
        // bottom: 0.4rem;
        width:3rem;
       z-index: 0;
      }
    .img3{
        position: absolute;
      right: 0px;
      top: 0.6rem;
    }

        .four{
        position: absolute;
          top: 2rem;
          right: 0.2rem;
          z-index: 999;
          width: 0.14rem;
        }
        .five{
        position: absolute;
          top: 2rem;
          right: 0.2rem;
          width: 0.22rem;
        }
}
  .total{
    margin-top: 0.1rem;
    z-index: 999;
    position: relative;
    flex: 0.8;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .one{
      width:65%;
      display: block;
      margin:0 auto;
    }
    // .imgsome{
    //     width: 350px;
    //     margin: 0 auto;
    //     position: relative;
    //     img{
    //       position: absolute;
    //     }
    //     .one{
    //       left: calc(50% - 170px );
    //       width: 67px;
    //       top: 15px;
    //     }
    //     .two{
    //       width:309px;

    //       z-index: 999;
    //       left: calc(50% - 154px );

    //     }
    //     .three{
    //     width: 67px;
    //       right:calc(50% - 170px );
    //       top: 15px;
    //       z-index: 99;
    //     }
    //     span{
    //       position: absolute;
    //       width: 300px;
    //       font-weight: 400;
    //       font-size: 24px;
    //       line-height: 40px;
    //       color: #FFFFFF;
    //       align-items: center;
    //       text-align: center;
    //       z-index:1000;
    //       top: 12px;
    //       left: calc(50% - 150px );
    //     }


      // }
    .textimg{
            width: 80%;
            margin: 0px  auto;
            // margin-top: 80px;
            z-index: 9999;
            div{
              display: flex;
              align-items: center;
              margin: 0 auto 0.1rem;
                img{
                  width:0.2rem;
                  margin-right: 0.1rem;
                }
              span{
                font-weight: 400;
                font-size: 0.14rem;
                color: #C62727;
                z-index: 9999999999;
              }

            }
    }
    .ocntrnon{
      width: 63%;
      display: flex;
      margin: 0 0 0.1rem 0.1rem;
      span{
        font-size: 0.12rem;
        color: #000000;
        font-family: YuanZhunGBK;
        font-weight: 400;
      }
      div{
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items:center;
        justify-content: space-between;
        .frameimg{
          position: absolute;
          bottom: 55px;
          left: 20px;
        }
        img{
          width:0.4rem;
        }
        span{
          margin-top: -0.05rem;
          letter-spacing: -0.015em;
        }
      }

    }
    .kemu{
        position: absolute;
        right: -0.19rem;
        bottom: 0.2rem;
        padding: 0 0.23rem 0 0.1rem;
        background: linear-gradient(98.21deg, #8A8AFF 43.7%, #A39ED2 112.09%);
        border-radius: 3px;
        span{
          display: block;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          text-align: center;
          letter-spacing: -0.015em;
          color: #FFFFFF;
          margin: 5px auto;
        }
      }

  }
  .el-main{
    // width:100%;
    overflow: initial;
    padding:0;
    z-index: 999;
    flex:1.2;
    // margin-top:-200px;
    margin:0 0.1rem 0.1rem;
    // position: absolute;
    // bottom:30px;
    // height: calc(100vh - 100px);
    // z-index: 2147483005;
    .login_form{
      // width:100vw;
      height:100%;
      position: relative;

      /deep/ .el-form{
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          // padding:13px 24px 25px;
          margin:0 auto;
          background: #FFFFFF;
          box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.18), 0px -4px 10px -4px rgba(16, 24, 40, 0.25);
          border-radius: 20px;
          color: #000000;
          font-size: 0.12rem;
        .el-form-item {
            // width: 100%;
            margin:0.12rem 0.08rem 0;
          //   .el-form-item__content{
          //     .el-input{
          //         /deep/ .el-input__inner:focus{
          //             border:1px solid hsl(0, 0%, 0%);
          //     }
          //     }

          //     .el-input.is-active .el-input__inner, .el-input__inner:focus{
          //         border:1px solid hsl(0, 0%, 0%);
          //     }
          // }
          .el-form-item__label{
            padding:0;
            line-height:initial;
            font-size: 0.12rem;
            margin-bottom:0.03rem;
          }
          .el-form-item__content{
                line-height: 30px;
                display: flex;
                margin:0!important;
            .el-input-group{
              .el-input__inner{
                      border-radius:0 6px 6px 0;
                line-height: 30px;
              }
              //   /deep/ .el-input__inner:focus{
              //         border:1px solid hsl(0, 0%, 0%);
              // }
            }
            .el-input-group__prepend{
              background: none;
              border:none;
              .el-input__inner{
                  border-radius:6px 0 0 6px;
              }
              .el-input__suffix{
                  .el-input__icon{
                    line-height: 30px;
                  }
                }
              //   /deep/ .el-input__inner:focus{
              //         border:1px solid hsl(0, 0%, 0%);
              // }
            }
            .el-input__inner{
              height: 40px;
                line-height: 30px;
              // background: #FFFFFF;
                /* Neutral/300 */

                border: 1px solid  #D1D5DB;
                box-sizing: border-box;
                /* Drop shadow/XSmall */
                box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                border-radius: 6px;
                  &::placeholder {
                    color: #D1D5DB;
                    font-weight:400;
                    font-size: 0.12rem;

                }
              //     /deep/ .el-input__inner:focus{
              //         border:1px solid hsl(0, 0%, 0%);
              // }
            }
            .el-form-item__error{
              padding-top:0.02rem;
              font-size: 0.1rem;
              color: #fc424c;
            }
          }
        }
        button{

        // padding: 10px 0;
            height: 0.4rem;
            margin:0.05rem 0.2rem;
            // background: #ff6440;
            // border-radius: 4px;
            border: none;
            color: #3A31A2;
            font-family: YuanCuGBK;
            // box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
            background: linear-gradient(92.62deg, #FECE0C 6.45%, #FA7979 91.98%);
            border-radius: 25px;
            font-size: 0.18rem;
            align-items: center;
            text-align: center;
        }
      }
    }
  }
  .el-input_search{
    margin-bottom:10px;
    img{
      width:18px;
      height:18px;
    }
    .el-input__inner{
      font-size: 12px;
    }
  }
/deep/ .el-select-dropdown__item{
    font-size: 12px;
    height: 30px;
    line-height: 30px;
}
.demo-shareForm{
  .demodiv{
    margin:0.15rem 0.2rem 0;
  }

}

 .founten{
  position: absolute;
  right: -0.1rem;
  bottom: 0.1rem;
  z-index: 9999999999999999999999999;
}


//en页面样式
.six{
        position: absolute;
        left:calc(50% - 0.35rem );
        top:1%;

        width:0.7rem;
        z-index: 0;
}
.seven{
  position: absolute;
        top: 0;
        left: 0;
        width:100%;
        z-index: 0;
}
.eight{
  position: absolute;
        top: 0;
        right: 0;
        width:100%;
        z-index: 1;
}
.nite{
   position: absolute;
        top: 4%;
        right: 0;
        width: 0.4rem;
        z-index: 1;
}
.ten{
  position: absolute;
        top: 87%;
        right: 0;
        width: 0.68rem;
        height: 0.29rem;
        z-index: 1;
}

  .indexbground{
    background: #9AA3F1;
  }
  .total{
      .enspan{
        font-family: Kiddosy;
        width: 100%;
        font-weight: 400;
        font-size: 0.22rem;
        margin: 0.2rem auto 0;
        text-align: center;
      }
      .textimgen{

          margin: 0.05rem auto;
          div{
              background: #FFFFFF;
              border-radius: 37px;
              padding: 0.05rem 0;
              img{
                width:0.14rem;
                height: 0.14rem;
                margin: 0  0.08rem;
              }
              span{
                color: #000000;
                font-family: ArialRoundedMTBold;

                font-weight: 400;
                font-size: 0.11rem;
                // line-height: 0.23rem;
              }

          }
      }

  }
  /deep/.el-main{
    .login_form{
      .el-form{
        .buttonen{
           background: linear-gradient(92.62deg, #FC8643 6.45%, #EA5155 91.98%);
           span{
             color: #FFFFFF;
             font-size: 0.19rem;
            //  font-feature-settings: 'salt' on;
           }
        }
      }
    }
  }
 .ocntrnon_en{
    // position: absolute;
     width:4.34rem;
     margin-top: -0.45rem;
     margin-bottom: -0.18rem;
     left: 0;
     z-index: 9999999999999999999999999;
 }
 .elmain_en{
   z-index: 0;
 }
//  /deep/.el-main .login_form .el-form .el-form-item .el-form-item__content .inputfocus{
//    /deep/ .el-input__inner{
//        border:1px solid hsl(0, 0%, 0%);
//      }
//  }

  /deep/.el-main .login_form .el-form .el-form-item .el-form-item__content .inputfocus5 .el-input__inner{
    border:1px solid hsl(0, 0%, 0%);
  }
  /deep/.el-main .login_form .el-form .el-form-item .el-form-item__content .inputfocus{
     .el-input__inner{
        border:1px solid hsl(0, 0%, 0%);
     }
     .el-input{
       .el-input__inner{
        border:1px solid  #D1D5DB;
     }
     }
  }
    /deep/ .el-scrollbar{
        min-width: 320px;
    }
    /deep/.el-select{
    .el-input__inner{
         background-image: -webkit-linear-gradient(left, rgba(0, 0, 0,1), rgba(0, 0, 0, 0.2));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .el-input__suffix{
        background: #FFFFFF;
        height: 38px;
        top:1px;
    }

}
/deep/ section .right .forms_submit .el-form .el-form-item .el-form-item__content .el-select .el-input__inner{

font-style: normal;
font-weight: 500;
font-size: 14px;
color: #111827;
}
/deep/.el-select input{
  font-weight: 500;
  color: #111827;
}
</style>



// WEBPACK FOOTER //
// src/components/shareRegister.vue